import React, { useEffect, useState } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';
import Authorize from '../../components/AuthComponent/Authorize';
import SaveButton from '../../components/Buttons/SaveButton';
import ButtonBar from '../../components/Fields/ButtonBar';
import DateControl from '../../components/Fields/DateControl';
import Field from '../../components/Fields/Field';
import FieldLabel from '../../components/Fields/FieldLabel';
import Form from '../../components/Fields/Form';
import NumberField from '../../components/Fields/NumberField';
import SelectListField from '../../components/Fields/SelectListField';
import TextboxField from '../../components/Fields/TextboxField';
import { FormConfig } from '../../components/Fields/Types';
import useValidation from '../../components/Hooks/ValidationHook/useValidation';
import SpinnerOverlay from '../../components/Spinner/SpinnerOverlay';
import { ApplicationFunctions } from '../../contexts/authContext';
import { useNotifications } from '../../contexts/notificationContext';
import SizeModel from '../../models/SizeModel';
import DataService from '../../services/data.service';
import { Result } from '../../types/Result';
import Unauthorized from '../Authentication/Unauthorized';

const SizeView: React.FC = () => {
    const [formData, setFormData] = useState<SizeModel>();
    const [serverErrors, setServerErrors] = useState<Result>();
    const { handleResult, handleException } = useNotifications();
    const [isAuthorized, setIsAuthorized] = useState<boolean>(true);

    var id = useParams().id;

    useEffect(() => {
        if (id !== undefined) {
            DataService.getById<SizeModel>('api/v1/sizes/', id)
                .then(response => setFormData(response))
                .catch(e => {
                    if (e.response?.data?.status === 401)
                        setIsAuthorized(false);
                    else
                        handleException(e);
                });
        }
    }, [id]);

    function submit() {
        if (formData) {
            DataService
                .update<SizeModel>(`api/v1/sizes/`, formData)
                .then(response => {
                    handleResult(response);
                    setServerErrors(response);
                    if (response.isSuccesful === true && response.data)
                        setFormData(response.data);
                })
                .catch(e => handleException(e));
        }
    }

    const formConfig: FormConfig = {
        fields: [
            { name: 'sizeSet.name', label: 'Size set'},
            { name: 'name', label: 'Name', validationRules: [{ type: 'isRequired' }] },
            { name: 'sortOrder', label: 'Sort order', validationRules: [{ type: 'isNumber' }] },
            { name: 'beginDate', label: 'Active from', validationRules: [{ type: 'isRequired' }, { type: 'isDate' }] },
            { name: 'endDate', label: 'Active Until', labelSize: 'auto', validationRules: [{ type: 'isDate' }] },
        ],
        handleSubmit: submit,
        showErrors: 'always',
    };

    const { getFieldProps, getLabelProps, getControlProps, getSubmitButtonProps } = useValidation(formConfig, formData, serverErrors);

    if (!isAuthorized)
        return (<Unauthorized />);

    if (!formData)
        return <SpinnerOverlay />

    return (
        <div className='main-content'>
            <Form title='Size' footer={(
                <Row>
                    <Col md='12'>
                        <ButtonBar offset={2}>
                            <Authorize applicationFunction={ApplicationFunctions.EditSize}>
                                <SaveButton  {...getSubmitButtonProps()} />
                            </Authorize>
                        </ButtonBar>
                    </Col>
                </Row>
            )}>
                <Container fluid>
                    <Row>
                        <Col md='12'>
                            <TextboxField {...getFieldProps('sizeSet.name')} disabled />
                            <TextboxField {...getFieldProps('name')} />
                            <NumberField {...getFieldProps('sortOrder')} />
                            <Field {...getLabelProps('beginDate')}>
                                <DateControl {...getControlProps('beginDate')} />
                                <span style={{ padding: '7px 15px' }}><FieldLabel {...getLabelProps('endDate')} /></span>
                                <DateControl {...getControlProps('endDate')} />
                            </Field>
                        </Col>
                    </Row>
                </Container>
            </Form>
        </div>
    );
}
export default SizeView;